export const productColumns = [
    {
      name: 'Product Id',
      selector: row => row.id,
      width: "120px"
    },
    {
      name: 'Image',
      selector: row => row.productImage,
      width: "80px"
    },
    {
      name: 'Product Name',
      selector: row => row.productName,
      width: "180px"
    },
    {
      name: 'Description',
      selector: row => row.description,
      width: "305px"
      
    },
    {
      name: 'Rating',
      selector: row => row.ratings,
      width: "90px"
    },
    {
      name: 'Category',
      selector: row => row.category,
      width: "120px"
    },
    {
      name: 'Price(N)',
      selector: row => row.productPrice,
      width: "100px"
    },
    {
      name: 'Discount(N)',
      selector: row => row.discountPrice,
      width: "100px"
    },
    {
      name: 'Price(N)',
      selector: row => row.discountPrice,
      width: "100px"
    },
    {
      name: '',
      selector: row => row.edit,
      width: '50px'
      
    },
    {
      name: '',
      selector: row => row.delete,
      width: '50px'
    },
]

export const orderColumns = [
    {
      name: 'Order Id',
      selector: row => row.id,
      width: "100px"
    },
    {
      name: "Ordered By",
      selector: row => row.userName,
      width: "150px"
    },
    {
      name: 'Total Amount',
      selector: row => row.totalPrice,
      width: "120px"
    },
    {
      name: 'Delivery Type',
      selector: row => row.deliveryType,
      width: "115px"
    },
    {
      name: 'Address',
      selector: row => row.address
    },
    {
      name: 'Order Status',
      selector: row => row.status,
      width: "110px"
    },
    {
      name: 'Payment Status',
      selector: row => row.paymentStatus,
      width: "123px"
    },
    {
      name: 'Order Date',
      selector: row => row.dateOrdered,
      width: "132px"
    },
    {
      name: '',
      selector: row => row.view,
      width: "48px"
    }
]

  export const productsRow = [
    {
      "name": "Fresh Blueberries",
      "description": "Indulge in the exquisite taste of our fresh blueberries, handpicked from our sustainable farm. These plump, juicy berries burst with flavor and are perfect for snacking or adding to your morning pancakes. Grown with care and using organic farming practices, these blueberries are a guilt-free treat.",
      "category": "Fruits",
      "originalPrice": 22.99,
      "discountPrice": 19.99,
      "images": ["https://example.com/blueberry1.jpg", "https://example.com/blueberry2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-10-10",
        "weight": "0.5 kg",
        "SustainabilityPractice": "Organic farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Lucy",
            "email": "lucy@example.com"
          },
          "rating": 5,
          "comment": "These blueberries are simply amazing! They're sweet and incredibly fresh. Perfect for making blueberry muffins or topping my yogurt.",
          "productId": "product_id_107"
        }
      ],
      "ratings": 5,
      "shopId": "shop_id_7",
      "shop": {
        "name": "Berry Bliss Farm",
        "location": "456 Orchard Lane, Berrytown",
        "contact": "berries@example.com"
      }
    },
    {
      "name": "Organic Broccoli",
      "description": "Experience the goodness of organic broccoli, carefully cultivated on our sustainable farm. Packed with nutrients, these tender florets are perfect for steaming, roasting, or stir-frying. Our commitment to organic farming means you're making a healthy choice for your family.",
      "category": "Vegetables",
      "originalPrice": 25.99,
      "discountPrice": 22.99,
      "images": ["https://example.com/broccoli1.jpg", "https://example.com/broccoli2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-10-18",
        "weight": "0.6 kg",
        "SustainabilityPractice": "Organic farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Mark",
            "email": "mark@example.com"
          },
          "rating": 4,
          "comment": "Good broccoli, but some heads had minor blemishes. Great for making broccoli cheddar soup.",
          "productId": "product_id_108"
        }
      ],
      "ratings": 4,
      "shopId": "shop_id_8",
      "shop": {
        "name": "Green Garden Farms",
        "location": "789 Vegetable Avenue, Veggieland",
        "contact": "green@example.com"
      }
    },
    {
      "name": "Chickpeas",
      "description": "Our chickpeas are a versatile addition to your pantry. Grown on our farm, these chickpeas are rich in protein and ideal for making hummus, soups, and stews. Experience the convenience of having quality chickpeas at your fingertips.",
      "category": "Legumes",
      "originalPrice": 20.99,
      "discountPrice": 17.99,
      "images": ["https://example.com/chickpea1.jpg", "https://example.com/chickpea2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-09-25",
        "weight": "0.8 kg",
        "SustainabilityPractice": "Pesticide-free farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Olivia",
            "email": "olivia@example.com"
          },
          "rating": 5,
          "comment": "These chickpeas are a kitchen essential! They're consistently excellent and make the creamiest hummus.",
          "productId": "product_id_109"
        }
      ],
      "ratings": 5,
      "shopId": "shop_id_9",
      "shop": {
        "name": "Chickpea Delights",
        "location": "101 Legume Street, Hummusville",
        "contact": "chickpeas@example.com"
      }
    },
    {
      "name": "Wild Rice Blend",
      "description": "Savor the delightful flavors of our wild rice blend, carefully curated to provide a blend of textures and tastes. Ideal for pilafs, salads, or side dishes, this blend offers a harmonious combination of grains. Elevate your meals with a touch of wildness.",
      "category": "Grains",
      "originalPrice": 27.99,
      "discountPrice": 24.99,
      "images": ["https://example.com/wildrice1.jpg", "https://example.com/wildrice2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-09-30",
        "weight": "0.7 kg",
        "SustainabilityPractice": "Organic farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Daniel",
            "email": "daniel@example.com"
          },
          "rating": 4,
          "comment": "A tasty blend, but I found a few grains undercooked. It's a versatile choice for a variety of dishes.",
          "productId": "product_id_110"
        }
      ],
      "ratings": 4,
      "shopId": "shop_id_10",
      "shop": {
        "name": "Wild Grain Emporium",
        "location": "567 Grain Lane, Grainstown",
        "contact": "wildrice@example.com"
      }
    },
    {
      "name": "Tender Pork Chops",
      "description": "Indulge in the succulent tenderness of our pork chops, sourced from our trusted farm. Whether you prefer them grilled or pan-fried, these chops are packed with flavor and quality. We're dedicated to providing you with the best meat for your meals.",
      "category": "Meat",
      "originalPrice": 29.99,
      "discountPrice": 26.99,
      "images": ["https://example.com/porkchop1.jpg", "https://example.com/porkchop2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-10-10",
        "weight": "0.8 kg",
        "SustainabilityPractice": "Ethical farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Robert",
            "email": "robert@example.com"
          },
          "rating": 3,
          "comment": "The pork chops were good, but I expected a richer flavor. They cooked well, though. Decent for a weeknight dinner.",
          "productId": "product_id_111"
        }
      ],
      "ratings": 3,
      "shopId": "shop_id_11",
      "shop": {
        "name": "Pork Palace",
        "location": "789 Meat Street, Porktown",
        "contact": "pork@example.com"
      }
    },
    {
      "name": "Fresh Halibut Fillet",
      "description": "Delight in the delicate flavor of our fresh halibut fillet, a culinary masterpiece of the sea. Ideal for grilling or baking, this halibut offers a healthy and delectable choice. Sourced from our sustainable fishing practices, it's a testament to quality and care.",
      "category": "Seafood",
      "originalPrice": 31.99,
      "discountPrice": 28.99,
      "images":  ["https://example.com/halibut1.jpg", "https://example.com/halibut2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-10-12",
        "weight": "0.5 kg",
        "SustainabilityPractice": "Sustainable fishing"
      },
      "reviews": [
        {
          "user": {
            "name": "Emma",
            "email": "emma@example.com"
          },
          "rating": 5,
          "comment": "This halibut is simply divine! It's incredibly fresh and the perfect canvas for a gourmet meal. Highly recommended!",
          "productId": "product_id_112"
        }
      ],
      "ratings": 5,
      "shopId": "shop_id_12",
      "shop": {
        "name": "Ocean's Bounty Seafood",
        "location": "123 Seafood Avenue, Oceanville",
        "contact": "seafood@example.com"
      }
    },
    {
      "name": "Sweet Peaches",
      "description": "Experience the delightful sweetness of our juicy peaches, picked at the peak of ripeness. Whether you enjoy them fresh, in a pie, or as a topping, these peaches are the essence of summer. We take pride in delivering quality and flavor in every bite.",
      "category": "Fruits",
      "originalPrice": 26.99,
      "discountPrice": 23.99,
      "images":  ["https://example.com/peach1.jpg", "https://example.com/peach2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-09-20",
        "weight": "1.0 kg",
        "SustainabilityPractice": "Pesticide-free farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Ava",
            "email": "ava@example.com"
          },
          "rating": 4,
          "comment": "These peaches are delicious, but some were overripe. Great for making peach cobbler!",
          "productId": "product_id_113"
        }
      ],
      "ratings": 4,
      "shopId": "shop_id_13",
      "shop": {
        "name": "Peach Paradise Farm",
        "location": "456 Orchard Road, Peachville",
        "contact": "peaches@example.com"
      }
    },
    {
      "name": "Fresh Spinach",
      "description": "Discover the vibrant flavor of our fresh spinach, grown with care on our organic farm. Whether you're crafting a nutrient-packed salad or adding greens to your smoothie, our spinach is a nutritious choice. We're committed to delivering the best of nature to your table.",
      "category": "Vegetables",
      "originalPrice": 23.99,
      "discountPrice": 19.99,
      "images": ["https://example.com/spinach1.jpg", "https://example.com/spinach2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-10-22",
        "weight": "0.4 kg",
        "SustainabilityPractice": "Organic farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Noah",
            "email": "noah@example.com"
          },
          "rating": 5,
          "comment": "This spinach is incredibly fresh and the perfect addition to my salads. It's crunchy and full of flavor!",
          "productId": "product_id_114"
        }
      ],
      "ratings": 5,
      "shopId": "shop_id_14",
      "shop": {
        "name": "Green Leaf Farms",
        "location": "101 Vegetable Street, Veggieville",
        "contact": "spinach@example.com"
      }
    },
    {
      "name": "Black Beans",
      "description": "Savor the rich and earthy taste of our black beans, sourced from our trusted farm. These beans are versatile and perfect for a variety of dishes, from burritos to soups. We're dedicated to providing you with top-quality beans for your culinary creations.",
      "category": "Legumes",
      "originalPrice": 21.99,
      "discountPrice": 18.99,
      "images": ["https://example.com/bean1.jpg", "https://example.com/bean2.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-09-28",
        "weight": "0.9 kg",
        "SustainabilityPractice": "Pesticide-free farming"
      },
      "reviews": [
        {
          "user": {
            "name": "Liam",
            "email": "liam@example.com"
          },
          "rating": 4,
          "comment": "These black beans are great for my Mexican dishes. Some beans were smaller than others, but they cook well and taste good.",
          "productId": "product_id_115"
        }
      ],
      "ratings": 4,
      "shopId": "shop_id_15",
      "shop": {
        "name": "Bean Haven",
        "location": "567 Legume Avenue, Beantown",
        "contact": "beans@example.com"
      }
    },
    {
      "name": "Wild-Caught Salmon Fillet",
      "description": "Delight in the exceptional flavor of our wild-caught salmon fillet, a symbol of the pristine waters of our sources. Whether you grill, bake, or broil, this salmon offers a healthy and mouthwatering choice. Sourced with care and sustainability in mind.",
      "category": "Seafood",
      "originalPrice": 28.99,
      "discountPrice": 25.99,
      "images": ["https://example.com/salmon3.jpg", "https://example.com/salmon4.jpg"],
      "additionalInfo": {
        "HarvestDate": "2023-10-08",
        "weight": "0.6 kg",
        "SustainabilityPractice": "Wild-caught"
      },
      "reviews": [
        {
          "user": {
            "name": "Mia",
            "email": "mia@example.com"
          },
          "rating": 5,
          "comment": "This wild-caught salmon is a gem. It's exceptionally fresh and a treat for seafood lovers. Perfect for special occasions!",
          "productId": "product_id_116"
        }
      ],
      "ratings": 5,
      "shopId": "shop_id_16",
      "shop": {
        "name": "Sustainable Seas Seafood",
        "location": "789 Ocean Road, Seafoodville",
        "contact": "seasfood@example.com"
      }
    },
    // Add more products as needed
  ];
  
  
  
    